import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { isEmpty, orderBy } from "lodash";

import { Collapse } from "react-bootstrap";

import * as callActions from "../../actions/callActions";
import * as modalActions from "../../actions/modalActions";

import ExpenseApprovalContainer from "./ExpenseApprovalContainer";
import Badge from "../common/Badge";

class ExpenseUserContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      expenses: this.props.expenses ? [...this.props.expenses] : []
    };
  }

  onSelectAll = (e) => {
    const { data, open, allSelected } = this.state;
    e.stopPropagation();
    this.setState(
      { data, open: open ? true : !open, allSelected: !allSelected },
      () => this.selectAll()
    );
  };

  handleOpen = (e) => {
    if (e.target.className !== "checkbox-custom") {
      this.setState({ open: !this.state.open });
    }
  };

  render() {
    const {
      user,
      expenses,
      onClickView,
      onClickDelete,
      updateExpense,
      onMarkAsComplete,
      codes
    } = this.props;
    const { open } = this.state;
    return (
      !isEmpty(expenses) && (
        <React.Fragment>
          <Card open={open} onClick={this.handleOpen}>
            <span
              style={
                user && !user?.is_active
                  ? { color: "red", fontWeight: "bold" }
                  : { fontWeight: "bold" }
              }
            >
              {user?.full_name}
            </span>
            <Badge className="badge success">
              {expenses.length} {expenses.length === 1 ? "Expense" : "Expenses"}
            </Badge>
            <Totals data={expenses} />
            {open ? <IoChevronUp size={20} /> : <IoChevronDown size={20} />}
          </Card>
          <Collapse in={open}>
            <div
              style={{
                borderBottom: "2px solid #50accb"
              }}
            >
              {orderBy(expenses, "date", "asc").map((expense) => (
                <div key={expense._id}>
                  <ExpenseApprovalContainer
                    auth={this.props.auth}
                    expense={expense}
                    updateExpense={updateExpense}
                    onClickView={onClickView}
                    onClickDelete={onClickDelete}
                    onMarkAsComplete={onMarkAsComplete}
                    reimbursed={expense.to_employee_complete}
                    billed={expense.to_customer_complete}
                    codes={codes}
                  />
                </div>
              ))}
            </div>
          </Collapse>
        </React.Fragment>
      )
    );
  }
}

const Card = styled.div`
  display: grid;
  grid-template-areas: "checkbox name badge flagged totals icon";
  grid-template-columns: 2fr 1fr 1fr 1fr 4fr auto;
  grid-gap: 25px;
  align-items: center;
  padding: 15px 5px;
  font-family: "Open Sans";
  border-bottom: ${(props) => (!props.open ? "1px solid #efefef" : "none")};
  * {
    cursor: pointer;
  }
  &:hover {
    cursor: pointer;
  }
  strong {
    margin: 0;
    letter-spacing: 0 !important;
    grid-area: name;
  }
  .badge {
    margin: 0;
    width: 80px;
    &.success {
      grid-area: badge;
      background: ${(props) => props.theme.green_g} !important;
    }
    &.danger {
      background: ${(props) => props.theme.red_g};
      grid-area: flagged;
    }
  }
  svg {
    grid-area: icon;
  }
  .footer-totals {
    grid-area: totals;
    display: flex;
    justify-content: space-around;
    p {
      font-family: "Open Sans";
      margin-bottom: 0;
    }
  }
`;

const Totals = ({ data }) => (
  <span className="footer-totals">
    <p>
      <label htmlFor="total-hours">Total Expensed: </label>{" "}
      {data.length
        ? `$${data.reduce((total, b) => total + (b.total || 0), 0).toFixed(2)}`
        : "--"}
    </p>
  </span>
);

Totals.propTypes = {
  data: PropTypes.array
};

ExpenseUserContainer.propTypes = {
  expenses: PropTypes.object,
  user: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onClickView: PropTypes.func,
  onClickDelete: PropTypes.func,
  updateExpense: PropTypes.func,
  onMarkAsComplete: PropTypes.func,
  codes: PropTypes.array,
  auth: PropTypes.object.isRequired
};

function mapStatesToProps(state) {
  return {
    callToSave: state.reducers.callToSave,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...modalActions, ...callActions }, dispatch)
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(ExpenseUserContainer);
